import Container from '@rentivo/gatsby-core/src/components/ui/Container/component';

Container.defaultProps = {
  fluid: false,
  content: false
};

export default Container;
